/** Reads the component's actual committed element; never alters a view or its revision. */
export function visibleProjectionText(node, text) {
  if (!node?.isConnected || document.visibilityState !== 'visible' || node.textContent !== text) return false;
  const box = node.getBoundingClientRect();
  if (box.width <= 0 || box.height <= 0 || box.top < 0 || box.left < 0
      || box.right > window.innerWidth || box.bottom > window.innerHeight) return false;
  let parent = node, depth = 0;
  while (parent && depth++ < 32) {
    const style = window.getComputedStyle(parent);
    if (style.display === 'none' || style.visibility !== 'visible' || Number(style.opacity) === 0) return false;
    parent = parent.parentElement;
  }
  if (parent) return false;
  const hit = document.elementFromPoint(box.left + box.width / 2, box.top + box.height / 2);
  return !!hit && (node === hit || node.contains(hit));
}
